<section class="section overview">
  <div class="container">
    <div class="row align-items-center gap-y">
      <div
        *ngIf="seleccionada == 1"
        class="col-lg-8 mr-auto text-center text-md-left"
      >
        <div class="section-heading">
          <!-- <dc-badge [bg]="'success'" [text]="'contrast'">
            Succeed with DashCore
          </dc-badge> -->
          <h2>Terminos y condiciones</h2>

          <p class="lead text-secondary">
            1. Alcance<br />
            Los siguientes términos generales y condiciones de INC Loud 2000,
            S.L. (en adelante, “Grupo X3 o “El Titular”), aplican a su pedido en
            la versión vigente en el momento de realizar el pedido.<br />
            Los términos y condiciones se aplican exclusivamente a
            contrataciones realizadas a través del portal de Internet y
            cumplirán con lo dispuesto en la legislación vigente y, en
            particular, en el Real Decreto Legislativo 1/2007, de 16 de
            noviembre, por el que se aprueba el texto refundido de la Ley
            General para la Defensa de los Consumidores y Usuarios y otras leyes
            complementarias.
          </p>
        </div>
      </div>
      <div
        *ngIf="seleccionada == 2"
        class="col-lg-8 mr-auto text-center text-md-left"
      >
        <div class="section-heading">
          <!-- <dc-badge [bg]="'success'" [text]="'contrast'">
            Succeed with DashCore
          </dc-badge> -->
          <h2>Aviso legal</h2>

          <p class="lead text-secondary">
            Cumpliendo lo establecido en el artículo 10 de la Ley 34/2002, de 11
            de julio, de servicios de la sociedad de la información y de
            comercio electrónico, a continuación, proporcionamos los datos
            necesarios del titular de la página web www.horax3.com (en adelante,
            la “Página Web”) prestador del servicio:
          </p>
        </div>

        <p>
          Razón social: INC Loud Solutions 2000, S.L.
          <br />
          CIF: B05541966
          <br />
          Dirección: Avenida de la innovación, 11, 41019, Sevilla.
        </p>
      </div>
      <div
        *ngIf="seleccionada == 3"
        class="col-lg-8 mr-auto text-center text-md-left"
      >
        <div class="section-heading">
          <!-- <dc-badge [bg]="'success'" [text]="'contrast'">
            Succeed with DashCore
          </dc-badge> -->
          <h2>Cookies</h2>

          <p class="lead text-secondary">
            Ponemos a disposición del usuario la presente política de cookies,
            donde podrán encontrar todos los detalles acerca del uso de cookies
            en nuestra página web. Aconsejamos a los usuarios que visiten la
            presente política de cookies con frecuencia, ya que ésta puede ser
            actualizada en cualquier momento.
          </p>
        </div>

        <p>
          ¿Qué son las cookies? Las cookies son pequeños ficheros que se
          instalan en el equipo del usuario cuando éste accede a un sitio web.
          Las cookies permiten, entre otras cosas, almacenar y recuperar
          información sobre los hábitos de navegación de un usuario o de su
          equipo y, dependiendo de la información que contengan y de la forma en
          que utilice su equipo, dependiendo del tipo de cookie y de la
          información que recaben, pueden utilizarse para reconocer al usuario.
        </p>
      </div>
      <div
        *ngIf="seleccionada == 4"
        class="col-lg-8 mr-auto text-center text-md-left"
      >
        <div class="section-heading">
          <!-- <dc-badge [bg]="'success'" [text]="'contrast'">
            Succeed with DashCore
          </dc-badge> -->
          <h2>Política de privacidad</h2>

          <p class="lead text-secondary">
            DashCore is a Bootstrap 4 HTML template. Designed to help you
            promote your solution in an easy and beautiful way.
          </p>
        </div>

        <p>
          It includes multiple components and pre-made demos ready for you to
          personalize according to your own needs. DashCore includes a
          ready-to-go Admin Dashboard with many out-of-the-box features.
        </p>
      </div>

      <div class="col-lg-4">
        <div class="row gap-y">
          <div
            class="col-6 col-sm-5 col-md-6"
            [ngClass]="card.class"
            *ngFor="let card of cards"
          >
            <button
              (click)="seleccionoCard(card)"
              [ngClass]="card.bg"
              class="card rounded p-2 p-sm-4 shadow text-center text-md-left "
            >
              <dc-feather
                [name]="card.icon"
                [iconClass]="card.iconClass"
              ></dc-feather
              >{{ card.title }}
            </button>
            <!-- <div (click)="seleccionoCard(card.id)"
              class="card rounded p-2 p-sm-4 shadow text-center text-md-left"
              [ngClass]="card.bg"
              [attr.data-aos]="card.animation"
            >
              <dc-feather
                [name]="card.icon"
                [iconClass]="card.iconClass"
              ></dc-feather>
              <p >{{ card.title }}</p>
             <p class="text-muted small">{{ card.description }}</p> 
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center gap-y">
      <div
        *ngIf="seleccionada == 2"
        class="col-lg-12 mr-auto text-center text-md-left"
      >
        <div class="section-heading">
          <p class="lead text-secondary">2. Condiciones generales de uso</p>
          <p>
            Las presentes condiciones generales de uso y navegación (en
            adelante, las “Condiciones”), tienen como objetivo regular la
            relación entre el titular de la página web, como prestador del
            servicio, y los usuarios que acceden, navegan y disfrutan del
            servicio ofrecido (en adelante, referido de forma individual como el
            “Usuario” o de forma colectiva como los “Usuarios”).
            <br />
            La Página Web proporciona a los Usuarios información general acerca
            de los productos y servicios de SESAME LABS (en adelante, el
            “Contenido”), todo ello de acuerdo con las presentes Condiciones.
            <br />
            Si el usuario continúa navegando y haciendo uso de los servicios que
            ofrecemos a través de nuestra Página Web, éste acepta sin reservas
            de algún tipo, las presentes Condiciones de uso.
            <br />
            El titular de la Página Web se reserva el derecho de modificar las
            presentes Condiciones en cualquier momento y a su sola discreción,
            por lo que aconsejamos al Usuario que las revise frecuentemente.
          </p>
          <p class="lead text-secondary">
            3. Acceso y registro en el sitio Web
          </p>
          <p>
            El acceso a la mayoría de contenidos del Sitio Web es completamente
            gratuito y no requiere registro previo, sin perjuicio de que pueden
            existir apartados o servicios particulares que requieran el registro
            previo, y en su caso pueden implicar el abono de cantidades
            económicas, de lo que será informado el usuario de forma previa,
            debiendo aceptar las correspondientes condiciones de contratación.
            <br />
            El usuario debe ser mayor de dieciocho (18) años. Queda prohibido el
            acceso a la Web por parte de menores de edad. No obstante, en caso
            de acceso al Sitio Web por parte de un menor, se presumirá que dicho
            acceso se ha realizado con autorización previa y expresa de sus
            padres, tutores o representantes legales, sin perjuicio de que el
            Prestador se reserva el derecho a realizar cuantas verificaciones
            considere oportunas.
            <br />
            Bajo ningún concepto el Prestador se responsabilizará de la
            veracidad de los datos de registro facilitados por los usuarios, por
            lo que cada uno de éstos será el único responsable de las posibles
            consecuencias, errores y fallos que pudieran derivarse de la falta
            de calidad de los datos.lizada.
          </p>
          <p class="lead text-secondary">
            4. Propiedad intelectual e industrial
          </p>
          <p class="lead text-secondary">
            a. Protección legal de los contenidos
          </p>
          <p>
            El titular de la Página Web lo es también de los derechos de
            explotación de propiedad intelectual e industrial de la Página Web
            incluyendo todos los Contenidos y elementos de la misma (a título
            enunciativo, textos, imágenes, audio y videos) disponibles desde la
            Página Web, así como de los que haya alojado en sitios de terceros
            bien porque son de su propiedad, bien porque ha obtenido los
            derechos oportunos para su utilización. Igualmente, el titular ha
            obtenido las autorizaciones oportunas relativas a derechos de imagen
            de quienes aparecen en su Página Web.
            <br />
            Queda prohibida la reproducción total o parcial, copia o
            distribución del Contenido, sin autorización expresa por parte del
            titular. En ningún caso se entenderá que el acceso y navegación del
            Usuario, implica una renuncia, transmisión, licencia o cesión total
            ni parcial de dichos derechos por parte del titular de la Página
            Web. Asimismo, está prohibido modificar, copiar, reutilizar,
            explotar, reproducir, comunicar públicamente, transmitir, usar,
            tratar o distribuir de cualquier forma la totalidad o parte de los
            Contenidos y elementos de la Página Web para propósitos públicos o
            comerciales, si no se cuenta con la autorización expresa y por
            escrito del titular de la misma.
            <br />
            Por lo tanto, de acuerdo con el párrafo anterior, el Usuario podrá,
            además de visualizar los Contenidos y elementos de la Página Web,
            realizar impresiones, copias o descargas de los mismos siempre que
            tales acciones estén dirigidas exclusivamente a su uso personal y
            privado.
            <br />
            Queda asimismo prohibida la utilización de los datos de contacto del
            titular (dirección postal, dirección de correo electrónico) para el
            envío de cualquier tipo de comunicación comercial, salvo que
            previamente se cuente con las necesarias autorizaciones conforme
            dispone la normativa aplicable.
          </p>
          <p class="lead text-secondary">b. Marcas y logotipos asociados</p>
          <p>
            Las marcas incorporadas en la Página Web pertenecen a su titular o a
            terceros, contando con la autorización de éstos para su uso en la
            Página Web.
            <br />
            Quienes navegan por la Página Web tienen prohibido utilizar dichas
            marcas, logotipos y signos distintivos sin la autorización del
            titular o licencia de uso de las mismas.
          </p>
        </div>
      </div>
      <div
        *ngIf="seleccionada == 3"
        class="col-lg-12 mr-auto text-center text-md-left"
      >
        <div class="section-heading">
          <h5>Tipo de cookies</h5>
          <p class="lead text-secondary">
            a) Según la entidad que gestiones las coockies:
          </p>
          <p>
            –Cookies propias: son aquéllas que se envían al dispositivo o
            terminal del usuario desde nuestro equipo o dominio, además son
            gestionadas por nosotros mismos, como titulares y editores de la
            presente página web.
            <br />
            –Cookies de terceros: son aquéllas que son enviadas al dispositivo o
            terminal del usuario desde un equipo o dominio que no es gestionado
            por nosotros mismos, sino por un tercero que tratará la información
            obtenida a través de las cookies.
          </p>
          <p class="lead text-secondary">b) Según el tiempo de conservación:</p>
          <p>
            – Cookies de sesión: son aquellas que recaban y almacenan los datos
            cuando el usuario accede a la página web y cesan una vez que el
            usuario sale de ésta.
            <br />
            – Cookies persistentes: son aquéllas que tienen una duración
            determinada en el tiempo por el responsable del tratamiento. El
            tiempo de conservación puede variar entre unos minutos a varios
            años. Se utilizan para guardar y recuperar ciertos parámetros cada
            vez que el usuario visite la página web.
          </p>
          <p class="lead text-secondary">c) Según su finalidad:</p>
          <p>
            – Cookies técnicas: son aquéllas imprescindibles y estrictamente
            necesarias para el correcto funcionamiento de la página web y
            utilizar las diferentes opciones o servicios que ofrecemos. Por
            ejemplo, las que sirven para el mantenimiento de la sesión, la
            gestión del tiempo de respuesta, rendimiento o validación de
            opciones, utilizar elementos de seguridad, compartir contenido con
            redes sociales, etc.
            <br />
            – Cookies de personalización: son aquéllas que permiten que el
            usuario pueda especificar o personalizar algunas características de
            la página web. Por ejemplo, definir el idioma, configuración
            regional o tipo de navegador.
            <br />
            – Cookies de análisis: son aquéllas que nos permiten realizar un
            seguimiento y análisis del comportamiento del usuario en nuestra
            página web para elaborar perfiles de navegación y poder conocer las
            preferencias de los usuarios del mismo. Se suelen utilizar para
            medir la actividad del usuario con el objetivo de mejorar el
            servicio que le ofrecemos en función de los resultados que
            obtenemos. Por ejemplo, mediante una cookie analítica se
            controlarían las áreas geográficas de mayor interés de un usuario,
            cuál es el producto o servicio de más aceptación, etc.
            <br />
            – Cookies publicitarias: son aquéllas que nos permiten la gestión de
            los espacios publicitarios en los sitios web.
            <br />
            – Cookies de publicidad comportamental: son aquéllas que permiten la
            gestión de los espacios publicitarios de nuestra página web. La
            función de estas cookies es almacenar información del comportamiento
            de los usuarios en nuestra página web, para posteriormente mostrar
            publicidad personalizada.
          </p>
          <p class="lead text-secondary">¿Qué cookies utilizamos?</p>
          <p>
            En concreto, utilizamos cookies de los siguientes terceros con las
            finalidades especificadas: Google Analytics (Google, Inc.): Usamos
            cookies de Google Analytics para medir la interacción de los
            usuarios con el contenido del sitio. Puede obtener más información
            acerca de Google Analytics a través del siguiente enlace. Google se
            encuentra adscrito a la herramienta Web Choices, desde la cual,
            puede deshabilitar el uso de sus cookies:
            https://optout.aboutads.info/. Puede evitar la instalación de
            cookies de Google Analytics con la siguiente extensión para su
            navegador. Google Adsense (Google, Inc.): Usamos cookies de Google
            para mostrar publicidad basada en el comportamiento de los usuarios.
            Puede obtener más información a través del siguiente enlace. Google
            se encuentra adscrito a la herramienta Web Choices, desde la cual,
            puede deshabilitar el uso de sus cookies:
            https://optout.aboutads.info/. Del mismo modo, le usuario puede
            evitar que la publicidad se base en su comportamiento a través de la
            siguiente herramienta. Pixel Tags: Utilizamos pixel tags para
            rastrear -de manera global exclusivamente- el uso que nuestros
            clientes hacen del Sitio Web y conocer cuáles son sus preferencias
            (tales como el país o el idioma elegidos). Esto nos permite poner a
            disposición de nuestros clientes determinados servicios así como
            mejorar la navegación. Pueden obtener más información en el
            siguiente enlace Yandex Metrica (Yandex N.V.): Usamos cookies de
            Yandex Metrica para medir la interacción de los usuarios con el
            contenido del sitio web. Puede obtener más información a través del
            siguiente enlace. Addthis (AddThis LLC): Usamos cookies de Addthis
            para permitir a los visitantes la compartición una página a través
            de Facebook, Twitter, correo electrónico y otros medios. Pueden
            obtener más información aquí.
          </p>

          <p class="lead text-secondary">
            ¿Cómo deshabilitar o eliminar las cookies?
          </p>
          <p>
            Los usuarios pueden, en cualquier momento, deshabilitar o eliminar
            las cookies enunciadas a través de la configuración de las opciones
            del navegador utilizado en su dispositivo o terminal. Los usuarios
            deben tener en cuenta que, si rechaza o borra las cookies de
            navegación para la página web, no podremos mantener sus preferencias
            y algunas características del mismo no estarán operativas, por lo
            que no podremos ofrecerle servicios personalizados y cada vez que
            vayan a navegar por nuestra página web tendremos que solicitarle de
            nuevo su autorización para el uso de cookies. A continuación,
            ofrecemos enlaces en los que el usuario encontrará información sobre
            cómo activar tus preferencias en los principales navegadores: <br />

            Configuración de cookies para Google Chrome <br />

            Configuración de cookies para Mozilla Firefox <br />

            Configuración de cookies para Internet Explorer <br />

            Configuración de cookies para Safari
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
